<template>
    <modal id="poll-response-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('pollResponse')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.POLL_RESPONSE'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('pollResponses.answer_text')"
                        type="text"
                        v-model="formData.answer_text"
                        :placeholder="$placeholder('pollResponses.answer_text')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'answer_text')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('pollQuestion')"
                        list-value-field="question_text"
                        v-model="formData.poll_question_id"
                        :chooseLabel="$t('pollQuestion')"
                        :error-message="$errorMessage(errors, 'poll_question_id')"
                        :required="true"
                        :fetch-url="TENANT_SELECTABLE_POLL_QUESTION"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('pollOption')"
                        list-value-field="option_text"
                        v-model="formData.poll_option_id"
                        :chooseLabel="$t('pollOption')"
                        :error-message="$errorMessage(errors, 'poll_option_id')"
                        :required="true"
                        :fetch-url="TENANT_SELECTABLE_POLL_OPTION"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {TENANT_SELECTABLE_POLL_QUESTION,TENANT_SELECTABLE_POLL_OPTION} from "../../../../Config/ApiUrl";


export default {
    name: "pollResponsesCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {},
            TENANT_SELECTABLE_POLL_QUESTION,
            TENANT_SELECTABLE_POLL_OPTION
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData.active_status = formData.active_status ? 1 : 0;
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.POLL_RESPONSE;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#poll-response-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'poll-response-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#poll-response-modal').modal('hide');
            this.toastAndReload(data.message, 'poll-response-table')
            this.$emit('input', false);
            window.location.reload();
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
